"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userFragmentDependencies = exports.userFragment = void 0;
const authorizationFragment_1 = require("./authorizationFragment");
exports.userFragment = `
fragment userFragment on User {
  email
  emailConfirmed
  authorization {
    ...authorizationFragment
  }
}
`.trim();
exports.userFragmentDependencies = [
    ...authorizationFragment_1.authorizationFragmentDependencies,
    authorizationFragment_1.authorizationFragment,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlckZyYWdtZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL2ZyYWdtZW50cy91c2VyRnJhZ21lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUVBR2lDO0FBRXBCLFFBQUEsWUFBWSxHQUFHOzs7Ozs7OztDQVEzQixDQUFDLElBQUksRUFBRSxDQUFDO0FBRUksUUFBQSx3QkFBd0IsR0FBRztJQUN0QyxHQUFHLHlEQUFpQztJQUNwQyw2Q0FBcUI7Q0FDdEIsQ0FBQyJ9